(function () {  
    var StickyStatesPlugin = window['@uirouter/sticky-states'].StickyStatesPlugin;
	var DSRPlugin = window['@uirouter/dsr'].DSRPlugin;

	angular
		.module('invesfleet', [
			'ngAria',
			'ngMessages',
			'ui.router',
			'angAccordion',
			'ngScrollbar',
			'ui.grid',
			'ui.grid.pagination',
			'ui.grid.grouping',
			'ui.grid.resizeColumns',
			'ui.grid.selection',
			'ui.grid.expandable',
			'720kb.tooltips',
			'ngMap',
			'datePicker',
			'luegg.directives',
			'highcharts-ng',
			'angularModalService',    
			'ui-notification',
			'ui.grid.pinning',
            'angular-google-analytics',
            'ngRoute',
            'angularjs.daterangepicker',
			'dndLists', 
			'rzSlider'
		]).config(['$uiRouterProvider', function ($uiRouterProvider) {
			$uiRouterProvider.plugin(StickyStatesPlugin);
			$uiRouterProvider.plugin(DSRPlugin);
        }])
		.config(function (NotificationProvider) {
			NotificationProvider.setOptions({
				delay: 10000,
				startTop: 30,
				startRight: 10,
				verticalSpacing: 10,
				horizontalSpacing: 20,
				positionX: 'right',
				positionY: 'bottom',
				maxCount: 4
			});
		})
		
		.config(['AnalyticsProvider', function (AnalyticsProvider) {
			// Add configuration code as desired
			AnalyticsProvider.setAccount('UA-113367954-1');
			AnalyticsProvider.trackUrlParams(true);
        }])
        // config-time dependencies can be injected here at .provider() declaration
        .provider('runtimeStates', function runtimeStates($stateProvider) {
            // runtime dependencies for the service can be injected here, at the provider.$get() function.
            this.$get = function ($q, $timeout, $state) { // for example
                return {
                    addState: function (name, state) {
                        $stateProvider.state(name, state);
                    }
                }
            }
        })
        .run(['$transitions', 'Analytics', function ($transitions, Analytics) {
			Analytics.registerTrackers();
			Analytics.trackPage(window.location.href);
			$transitions.onSuccess({}, function (a) {
				Analytics.trackPage(a.$to().name);
            });
		}]);
})();